import React, { useContext, useState } from 'react'
import { decryptData, encryptData } from '../../services/encryptDecryptService';
import { ThemeContext } from '../../layout/BaseLayout';

const ConnectionEncryptDecrypt = () => {

    let toast = useContext(ThemeContext);

    const [connectionValue, setConnectionValue] = useState("");
    const [outputValue, setOutputValue] = useState("")

    const getEncryptedValue = () => {
        if (!connectionValue) return
        encryptData(connectionValue).then((res) => {
            if (res) {
                setOutputValue(res?.data)
            }
        })
    }

    const getDecryptedValue = () => {
        if (!connectionValue) return
        decryptData(connectionValue).then((res) => {
            if (res) {
                setOutputValue(res?.data)
            }
        })
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(outputValue);
        toast.info("Copied!");
    }

    return (
        <div id='tabs'>
            <div className="maintitle-box">
                <div className="w-50 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/connectionencryptdescript.svg"} alt="" />Connection Encrypt Decrypt</h2>
                </div>
            </div>
            <div className='textarea-container'>

                <div className='row-align'>
                    <label className='textarea-label-left'>Encrypt:</label>
                    <textarea
                        className='custom-textarea'
                        value={connectionValue}
                        onChange={(e) => setConnectionValue(e.target.value)}
                    />
                </div>

                <div className='encdecbtn'>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => getEncryptedValue()}
                    >
                        Encrypt
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => getDecryptedValue()}
                    >
                        Decrypt
                    </button>
                </div>

                <div className='row-align'>
                    <label className='textarea-label-left'>Output:</label>
                    <div className='output-box' onClick={() => copyToClipboard()}>
                        {outputValue}
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ConnectionEncryptDecrypt